import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'hub-template-save-modal',
  styleUrls: [
    './template-save-modal.component.less',
  ],
  templateUrl: './template-save-modal.component.html',
  standalone: false
})
export class HubTemplateSaveModalComponent {
  @Input() dialogId: string = 'saveAsTemplateDialog';
  @Input() dialogTitle: string = 'Save as template';
  @Input() name: string;
  @Input() global: boolean = false;
  @Input() description: string;
  @Input() title: string;
  @Input() burtAdmin: boolean;
  @Input() approveButtonTitle: string = 'Save Template';
  @Input() app: 'dashboard' | 'report';
  @Output() saveChange = new EventEmitter<{ name: string, description: string, global: boolean }>();

  public draftName: string;
  public draftDescription: string;
  public draftGlobal: boolean;
  public invalidNameError: boolean = false;

  public fillFromInputs(): void {
    this.draftName = this.name;
    this.draftDescription = this.description;
    this.draftGlobal = this.global;
    this.invalidNameError = false;
  }

  public save(): void {
    this.invalidNameError = false;
    const pattern = new RegExp('^[a-zA-Z0-9_ .-]*$');
    if (!this.draftName.match(pattern)) {
      this.invalidNameError = true;
    } else {
      this.saveChange.emit({ name: this.draftName, description: this.draftDescription, global: this.draftGlobal || false });
    }
  }

  public get isDashboardApp() {
    return this.app === 'dashboard';
  }
}
